import { Alert, Button, Center, Stack } from '@mantine/core';
import type { ApiError } from '../lib/api';

/**
 * Distinct from NoAccess: this is "the admin check couldn't complete", not
 * "you don't have access". Reachable for a rate limit (429), a transient
 * server error (500, after retries are exhausted), or a network failure —
 * none of which say anything about the account's authorization.
 */
export function LoadFailed({ error, onRetry }: { error: ApiError | Error | null; onRetry: () => void }) {
  return (
    <Center h="100vh">
      <Stack w={420}>
        <Alert color="yellow" title="Couldn't check admin access">
          {error?.message ?? 'Something went wrong reaching the server.'} This isn&apos;t a
          decision about your access — try again.
        </Alert>
        <Button onClick={onRetry}>Try again</Button>
      </Stack>
    </Center>
  );
}
